import { forwardRef, Ref } from 'react';
// eslint-disable-next-line no-restricted-imports
import { NumberInput as ArcNumberInput, NumberInputProps } from 'arc';
import { useInputSizeForApplicationType } from '../common/hooks/use-input-size-for-application-type';

export const NumberInput = forwardRef(function (
    props: NumberInputProps,
    ref?: Ref<HTMLInputElement>
) {
    const { size: propsSize, ...otherProps } = props;
    const size = useInputSizeForApplicationType(propsSize);
    return <ArcNumberInput ref={ref} size={size} {...otherProps} />;
});
